<template>
  <div class="info-card">
    <div class="card-header">
      <img :src="image" alt="icon" class="card-icon" />

      <div class="card-text">
        <h3 class="card-title">{{ title }}</h3>
        <p class="card-description">{{ description }}</p>
      </div>
    </div>
    <div class="card-bottom">
      <a
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        class="view-details"
      >
       View details
      </a>
      <a :href="link" target="_blank" rel="noopener noreferrer">
        <VIcon name="arrow-right-line"></VIcon>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeatureInfoCard",
  props: {
    image: { type: String, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    link: { type: String, required: true },
  },
};
</script>

<style scoped>
.info-card {
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  padding: 28px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
}

.info-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  height: 100%;
}

.card-icon {
  width: 104px;
  height: 104px;
  border-radius: 12px;
  object-fit: contain;
}

.card-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: var(--black);
  margin: 0;
}

.card-description {
  color: var(--gray-04);
  font-size: 14px;
  line-height: 18px;
  margin: 0;
}
.card-bottom {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--background-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.view-details {
  font-size: 14px;
  font-weight: bold;
  color: var(--ion-color-primary);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 600px) {
  .info-card {
    padding: 20px;
    border-radius: 10px;
  }

  .card-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 14px;
  }

  .card-icon {
    width: 78px;
    height: 78px;
  }

  .card-bottom {
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
